import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ProposalFile } from './proposal-file';
import { ProposalLineItem } from './proposal-line-item';
import { ProposalRequestVendor } from './proposal-request-vendor';

export class Proposal extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ProposalProperties: (
    | {
        property: keyof Proposal;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof Proposal;
        type: 'alias';
      }
    | {
        property: keyof Proposal;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ProposalRequestVendorId', type: 'column', dataType: 'number' },
    { property: 'workStartDate', type: 'column', dataType: 'date' },
    { property: 'workFinishDate', type: 'column', dataType: 'date' },
    { property: 'comments', type: 'column', dataType: 'string' },
    { property: 'totalPrice', type: 'column', dataType: 'number' },
    { property: 'lI1', type: 'column', dataType: 'number' },
    { property: 'lI2', type: 'column', dataType: 'number' },
    { property: 'lI3', type: 'column', dataType: 'number' },
    { property: 'lI4', type: 'column', dataType: 'number' },
    { property: 'lI5', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'createdByClient', type: 'column', dataType: 'boolean' },

    {
      property: 'ProposalRequestVendor',
      model: 'ProposalRequestVendor',
      type: 'association'
    },
    { property: 'ProposalFiles', model: 'ProposalFile', type: 'association' },
    {
      property: 'ProposalLineItems',
      model: 'ProposalLineItem',
      type: 'association'
    }
  ];

  static {
    Proposal.ProposalProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        Proposal.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        Proposal.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        Proposal.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ProposalObject: Partial<Proposal>) {
    super();

    Proposal.ProposalProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ProposalObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ProposalRequestVendorId?: number;
  workStartDate?: Date;
  workFinishDate?: Date;
  comments?: string | null;
  totalPrice?: string;
  lI1?: string | null;
  lI2?: string | null;
  lI3?: string | null;
  lI4?: string | null;
  lI5?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
  createdByClient?: boolean;

  ProposalRequestVendor?: ProposalRequestVendor;
  ProposalFiles?: ProposalFile[];
  ProposalLineItems?: ProposalLineItem[];
}
